module.exports = __webpack_public_path__ + "images/icons_v2/network-3384c465.svg";